import axios from "axios";

let address = window.location.protocol + "//" + window.location.hostname + ":11001" 
const isDebug = process.env.NODE_ENV === "development" ? true : false;
if(isDebug) {
    address = window.location.protocol + "//" + "172.22.10.14" + ":11001" 
}
export const getConfig = async () =>{
    const config = (await axios.get(`${address}/ui-prs/config/get`)).data;
    return config;
}

export const getContacts = async () =>{
    const list = (await axios.get(`${address}/ui-prs/contacts/list_reporters`)).data;
    return list;
}

export const getEstablishedContacts = async () =>{
    const list = (await axios.get(`${address}/ui-prs/contacts/list`)).data;
    return list;
}

export const link = async (id) =>{
    const status = (await axios.post(
        `${address}/ui-prs/contacts/add`,
        {
            reporter_id: id
        })).status;
    return status;
}

export const unlink = async (id) =>{
    const status = (await axios.post(
        `${address}/ui-prs/contacts/delete`,
        {
            "contact_id": id
        })).status;
    return status;
}

export const getMessages = async() => {
    const messages = (await axios.get(`${address}/ui-prs/messages/list`)).data;
    return messages;
}

export const getDirections = async() => {
    const directions = (await axios.get(`${address}/ui-prs/messages/directions`)).data;
    return directions;
}

export const sendMessage = async (id, text) =>{
    const status = (await axios.post(
        `${address}/ui-prs/messages/send`,
        {
            "contact_id": id,
            "text": text
        })).status;
    return status;
}

export const sendRead = async (id, uid) =>{
    const status = (await axios.post(
        `${address}/ui-prs/messages/send_read`,
        {
            "contact_id": id,
            "uid": uid
        })).status;
    return status;
}

export const updateMessage = async (uid) => {
    const status = (await axios.post(`${address}/ui-prs/messages/update`,
    {
        "uid": uid,
        "datetime_read": Math.floor(Date.now() / 1000)
    })).status
    return status;
}
export const deleteMessage = async (id) =>{
    const status = (await axios.post(
        `${address}/ui-prs/messages/delete`,
        {
            "message_id": id,
        })).status;
    return status;
}

export const getTemplatesList = async () => {
    const templates = (await axios.get(`http://172.22.10.14:10505/patterns/getList`)).data;
    return templates;
}

export const getTemplateById = async (id) => {
    const template = (await axios.get(`http://172.22.10.14:10505/patterns/getPattern`, {params: {id: id}})).data;
    return template;
}

export const getAllTemplates = async () => {
    const template = (await axios.get(`http://172.22.10.14:10505/patterns/getAllPatterns`)).data;
    return template;
}

export const getAllDraftsForTemplate = async (id, prsAlias) => {
    const drafts = (await axios.get(`http://172.22.10.14:10505/patterns/getAllDraftsForTemplate`, {params: {id:id, prsAlias: prsAlias}})).data;
    return drafts;
}

export const addDraft = async (draftName, patternId, data, prsAlias) => {
    const result = (await axios.post(`http://172.22.10.14:10505/patterns/addDraft`, {
        draftName: draftName,
        patternId: patternId,
        prsAlias: prsAlias,
        data: data
    })).data
    return result;
}

export const deleteDraft = async (id) => {
    const result = (await axios.delete(`http://172.22.10.14:10505/patterns/deleteDraft`, { data: {id: id} })).data
    return result;
}



// export const createArticle = async (parentId, header = "TestHeader", content) =>{
//     const contentId = (await axios.post(
//         `${address}/site/createArticle`,
//         {
//             parentId: parentId,
//             header: header,
//             content: content
//         })
//         ).data;
//     console.log(contentId)
//     return contentId;
// }